import { useCallback, useLayoutEffect, useState } from 'react'

import enablePathDrag from './pathDrag'


const useLeafletImports = () => {
  const [ isImported, setImported ] = useState(false)

  const handleSetImported = useCallback((count?: number) => {
    if (window.L?.Handler?.PathDrag) {
      setImported(true)
    }
    else if (!count) {
      console.log('Enabling window.L.Handler.PathDrag')
      enablePathDrag()
      handleSetImported(1)
    }
    else if (!count) {
      console.log('window.L.Handler.PathDrag is not defined')
    }
  }, [])

  useLayoutEffect(() => {
    if (!__SERVER__) {
      import('leaflet-editable')
        .then(() => import('leaflet.heat'))
        .then(() => import('leaflet.markercluster'))
        .then(() => import('leaflet.path.drag'))
        .then(() => handleSetImported())
    }
  }, [ handleSetImported ])

  return { isImported }
}


export default useLeafletImports
